document.addEventListener("DOMContentLoaded", function() {
    
    // CONFIGURATION
    const radioGroupName = 'option-avis-0';
    const dropdownSelector = '.avis-swatch-option[data-option-index="1"]';

    // 1. The Logic Function
    function updateDropdownVisibility() {
        // Try to find the container
        const dropdownContainer = document.querySelector(dropdownSelector);
        const selectedRadio = document.querySelector(`input[name="${radioGroupName}"]:checked`);

        // SAFETY CHECK: If the container or radio doesn't exist yet, stop and wait.
        if (!dropdownContainer || !selectedRadio) {
            return false; // Return false to indicate not ready
        }

        // Apply logic
        if (selectedRadio.value === 'Personalizado') {
            dropdownContainer.style.display = 'block';
        } else {
            dropdownContainer.style.display = 'none';
        }
        
        return true; // Return true to indicate success
    }

    // 2. Event Delegation
    // Instead of attaching listeners to specific inputs (which might not exist yet),
    // we listen to the whole document for changes on that specific input name.
    document.addEventListener('change', function(e) {
        if (e.target && e.target.name === radioGroupName) {
            updateDropdownVisibility();
        }
    });

    // 3. The "Wait for App" Timer
    // Check every 500ms to see if the Avis app has loaded the elements
    const checkInterval = setInterval(function() {
        const isReady = updateDropdownVisibility();
        
        // If the function returns true, it means the elements are found and logic ran.
        // We can stop the timer.
        if (isReady) {
            clearInterval(checkInterval);
        }
    }, 500);
});